<div class="pt-3 pr-3">
  <h2>{{'PROJECTS_MODULE.ProjectBuilder.details' | translate}}</h2>
  <div class="pl-2">
    <formly-form [form]="projectBuilderService.projectForm" [model]="projectBuilderService.model" [fields]="fields"></formly-form>
  </div>
</div>
<app-project-tasks *ngIf="isProjectActive" [projectId]="projectBuilderService.model.id"></app-project-tasks>
<app-project-milestones *ngIf="isProjectActive" [projectId]="projectBuilderService.model.id"></app-project-milestones>
